// extracted by mini-css-extract-plugin
export default {"slide":"index_slide_-0xeE","big_pic":"index_big_pic_uduxa","text":"index_text_YxQj0","title":"index_title_Dhaqd","dot":"index_dot_CYeln","current":"index_current_GMsPR"};